import { Component, Input } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';

import { IBanner } from 'rev-portal/scheduledEvents/common/BannerTypes';

import styles from './VbWebcastBanner.module.less';

@Component({
	selector: 'vb-webcast-banner-at-end-dialog',
	templateUrl: './VbWebcastBannerAtEndDialog.Component.html',
	host: {
		'class': 'theme-primary'
	},
	standalone: false
})
export class VbWebcastBannerAtEndDialogComponent {
	@Input() public banners: IBanner[];

	public readonly styles = styles;

	constructor(
		private readonly modalInstance: BsModalRef
	) { }

	public onCloseClick(): void {
		this.modalInstance.hide();
	}

}
